module.exports = __webpack_public_path__ + "static/media/03-07.3935a848.png";